export type EnergyUsageByModelInput = {
  /**
   * Shipping line
   */
  shipping_line?: string;
  /**
   * Reefer id
   */
  reefer_id?: string;
  /**
   * Start date
   */
  start?: string;
  /**
   * End date
   */
  end?: string;
  /**
   * List of reefer ages
   */
  ages?: Array<number>;
  /**
   * Reefer mode
   */
  reefer_mode?: EnergyUsageByModelInput.reefer_mode;
  /**
   * List of reefer refrigeration unit models to filter on
   */
  refrigeration_unit_models?: Array<string>;
  /**
   * List of reefer manufacturers to filter on
   */
  manufacturers?: Array<string>;
  /**
   * List of tradelanes to filter on
   */
  tradelanes?: Array<string>;
  /**
   * Min setpoint temperature
   */
  min_setpoint?: number;
  /**
   * Max setpoint temperature
   */
  max_setpoint?: number;
  /**
   * List of Age ids
   */
  age_ids?: Array<string>;
  /**
   * List of temperature setpoint ids
   */
  temperature_setpoint_ids?: Array<string>;
  /**
   * Keep Controlled Atmosphere
   */
  ca?: boolean;
};

export namespace EnergyUsageByModelInput {
  /**
   * Reefer mode
   */
  export enum reefer_mode {
    STABLE = 'STABLE',
    TRANSITION = 'TRANSITION',
  }
}
